import { ModuleDefault } from '../default';

export class Read extends ModuleDefault {
    public getAll (params = {}) {
        const queryParams = this.utils.paramSerializer(params);
        return this.request.get(`${this.setup.urlBase}/merchants${queryParams}`);
    }
}
